import React from "react";
import "./Style.css";
import karthik from "../../assets/images/testi_img/Picture1.png";
import divya from "../../assets/images/testi_img/Picture2.png";
import lovely from "../../assets/images/testi_img/Picture3.png";
import meenal from "../../assets/images/testi_img/Picture4.png";
import manishImg from "../../assets/images/testi_img/Picture5.png";
import faisalImg from "../../assets/images/testi_img/Picture6.png";
import ahmedImg from "../../assets/images/testi_img/Picture7.png";

// Import react-slick and slick-carousel CSS
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    image: karthik,
    name: "Karthik R.",
    jobTitle: "Policy Holder",
    company: "SecureLife Insurance",
    text: "I greatly appreciate the RSA team at Across Assist for traveling 50 kilometers to help start my vehicle. I feared my trip would be ruined, but their assistance truly saved the day.",
  },
  {
    image: divya,
    name: "Divya Iyer",
    jobTitle: "Business Owner",
    company: "ShieldGuard Insurance",
    text: "I was on my way to a wedding in Coimbatore when my car battery gave up. I called RSA and within an hour, a technician named S. Aravind came and jump-started the vehicle. Super quick and helpful! Thank you for saving my day.",
  },
  {
    image: manishImg,
    name: "Lovely Singh",
    jobTitle: "Family Woman",
    company: "TrustCare Insurance",
    text: "Road assistance plan services are just awesome! I never knew  vehicle issues can be sorted with just a call. I lost my car keys while on a trip and Across Assist lost key service got me back on road within an hour.   ",
  },
  {
    image: meenal,
    name: "Meenal deshmukh",
    jobTitle: "Car Owner",
    company: "AutoSure Insurance",
    text: "Big thanks to the Across RSA team! My bike suddenly stopped near Malad late at night, and I didn’t know what to do. Within 40 minutes, a towing van reached me. Special shoutout to Rajeev from Pune who was calm and reassuring on the call. Appreciate the professionalism!",
  },
  {
    image: lovely,
    name: "Manish kudele",
    jobTitle: "Homeowner",
    company: "HomeGuard Insurance",
    text: "I greatly appreciate the RSA team at Across Assist for traveling 50 kilometers to help start my vehicle. I feared my trip would be ruined, but their assistance truly saved the day.",
  },
  {
    image: meenal,
    name: "Faisal Rahman",
    jobTitle: "Travel Enthusiast",
    company: "TravelSafe Insurance",
    text: "My Ola Electric consistently faced starting issues immediately after purchase, but each time it broke down, the Across Assist team was there to help me get back on the road.",
  },
  {
    image: lovely,
    name: "Ahmed Azad",
    jobTitle: "Travel Enthusiast",
    company: "TravelSafe Insurance",
    text: "My Ola Electric consistently faced starting issues immediately after purchase, but each time it broke down, the Across Assist team was there to help me get back on the road.",
  },
];

const sliderSettings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2500,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "0px",
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        centerMode: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        centerMode: false,
      },
    },
  ],
};

const CustomerReviews = () => {
  return (
    <>
      <section className="section-medium section-arrow--bottom-center section-arrow-primary-color bg-primary flex justify-center">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-white text-center">
              <h2 className="section-title"> What Others Say About Us</h2>
            </div>
          </div>
        </div>
      </section>
      <section className="section-primary t-bordered flex justify-center">
        <div className="container max-w-screen-xl" style={{ width: "100%" }}>
          <Slider {...sliderSettings}>
            {testimonials.map((t, idx) => (
              <div
                className="testimonial-card"
                key={idx}
                style={{ padding: "20px", height: "100%" }}
              >
                <div
                  className="container-testi-images-title flex"
                  style={{ alignItems: "center" }}
                >
                  <div className="testimonial-image" itemProp="image">
                    <img width="80" height="80" src={t.image} alt={t.name} />
                  </div>
                  <div
                    className="testimonial-meta"
                    style={{ marginLeft: "14px" }}
                  >
                    <strong className="testimonial-name" itemProp="name">
                      {t.name}
                    </strong>
                    <div
                      className="testimonial-stars"
                      style={{ marginTop: "4px" }}
                    >
                      {[...Array(5)].map((_, i) => (
                        <span
                          key={i}
                          style={{
                            color: "#FFD700",
                            fontSize: "1.1rem",
                            marginRight: "2px",
                          }}
                        >
                          &#9733;
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div
                  className="testimonial-content"
                  style={{ marginTop: "16px" }}
                >
                  <p>{t.text}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
};

export default CustomerReviews;

// const CustomerReviews = () => {
//   return (
//     <>
//       <section className="section-medium section-arrow--bottom-center section-arrow-primary-color bg-primary flex justify-center">
//         <div className="container">
//           <div className="row">
//             <div className="col-md-12 text-white text-center">
//               <h2 className="section-title"> What Others Say About Us</h2>
//             </div>
//           </div>
//         </div>
//       </section>
//       <section className="section-primary t-bordered flex justify-center">
//         <div className="container max-w-screen-xl ">
//           <div className="testimonial-grid">
//             {testimonials.map((t, idx) => (
//               <div className="testimonial-card" key={idx}>
//                 <div className="container-testi-images-title flex">
//                   <div className="testimonial-image" itemProp="image">
//                     <img width="80" height="80" src={t.image} alt={t.name} />
//                   </div>

//                   <div className="testimonial-meta">
//                     <strong className="testimonial-name" itemProp="name">
//                       {t.name}
//                     </strong>
//                     <div
//                       className="testimonial-stars"
//                       style={{ marginTop: "4px" }}
//                     >
//                       {[...Array(5)].map((_, i) => (
//                         <span
//                           key={i}
//                           style={{
//                             color: "#FFD700",
//                             fontSize: "1.1rem",
//                             marginRight: "2px",
//                           }}
//                         >
//                           &#9733;
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="testimonial-content">
//                   <p>{t.text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default CustomerReviews;
